import { ariaCreateExpander } from '@vo/js/utils/aria'

(function () {
    const toggles = document.querySelectorAll('[data-nav-toggle]')

    function handleToggleClick(event) {
        const toggle = event.currentTarget
        const target = document.querySelector(`#${toggle.getAttribute('aria-controls')}`)
        const expanded = toggle.getAttribute('aria-expanded') === 'true'

        target.classList.toggle('is-open')
        updateToggles(expanded ? 'false' : 'true')

        if (expanded) {
            document.body.classList.remove('overflow-hidden')
        } else {
            document.body.classList.add('overflow-hidden')
        }
    }

    function updateToggles(value) {
        toggles.forEach((toggle) => {
            toggle.setAttribute('aria-expanded', value)
        })
    }

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', handleToggleClick)
    })

    document
        .querySelectorAll('[data-module="mobile-nav-sub-toggle"]')
        .forEach((toggle) => ariaCreateExpander(toggle, { mode: 'class' }))
})()
